import { render, staticRenderFns } from "./WorkSummaryView.yaml?vue&type=template&id=4df98afc&component"
import script from "./WorkSummaryView.yaml?vue&type=script&lang=ts&component"
export * from "./WorkSummaryView.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports